import { setProductHidden, undoProductHidden } from '@/api/setProductHidden'
import { useState } from 'react'
import { useMutation } from 'react-query'

const useHideProduct = ({ initialVisibility, productId }: { initialVisibility: boolean; productId: number }) => {
  const [isVisible, setIsVisible] = useState(initialVisibility)
  const hideProductMutation = useMutation(setProductHidden)
  const unHideProductMutation = useMutation(undoProductHidden)

  const handleHideProduct = async () => {
    setIsVisible(!isVisible)
    const action = isVisible ? hideProductMutation : unHideProductMutation

    try {
      await action.mutateAsync({ productId })
    } catch (error) {
      setIsVisible(initialVisibility)
    }
  }

  return { isVisible, handleHideProduct }
}

export default useHideProduct
